import { memo } from 'react'
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material'

export interface BoxProps extends MuiBoxProps {}

function Box(props: BoxProps) {
  return <MuiBox {...props} />
}

export default memo(Box)
